import { render, staticRenderFns } from "./ModalVotantesRepetidos.vue?vue&type=template&id=39e29d6a&scoped=true"
import script from "./ModalVotantesRepetidos.vue?vue&type=script&lang=js"
export * from "./ModalVotantesRepetidos.vue?vue&type=script&lang=js"
import style0 from "./ModalVotantesRepetidos.vue?vue&type=style&index=0&id=39e29d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e29d6a",
  null
  
)

export default component.exports